import { TutorialDefinition, TutorialId } from './interfaces';
import { languageSettingsTutorial } from './definitions/languageSettings';
import { navigationBasicsTutorial } from './definitions/navigationBasics';
import { teleportTutorial } from './definitions/teleport';

export const TUTORIAL_REGISTRY: Record<TutorialId, TutorialDefinition> = {
  [TutorialId.NavigationBasics]: navigationBasicsTutorial,
  [TutorialId.LanguageSettings]: languageSettingsTutorial,
  [TutorialId.Teleport]: teleportTutorial,
};

export const TUTORIAL_ORDER: TutorialId[] = [
  TutorialId.NavigationBasics,
  TutorialId.LanguageSettings,
  TutorialId.Teleport,
];
